import React, { useEffect } from 'react';

const ThankYouModal = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                onClose(); // Modal automatisch sluiten na 3 seconden
                setTimeout(() => {
                    window.location.reload(); // Herlaad de pagina na de modal sluit
                }, 500); // Kleine vertraging om de modal correct te sluiten
            }, 3000); // 3 seconden

            return () => clearTimeout(timer); // Clear timer als de component wordt unmounted
        }
    }, [isOpen, onClose]);

    const handleClose = () => {
        onClose(); // Sluit de modal
        setTimeout(() => {
            window.location.reload(); // Herlaad de pagina na de modal sluit
        }, 500); // Kleine vertraging
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-black opacity-50 absolute inset-0" onClick={handleClose}></div>
            <div className="bg-white p-6 rounded shadow-lg relative z-10 w-80">
                <h2 className="text-lg font-semibold text-center text-[#175151]">Bedankt voor je boeking!</h2>
                <p className="text-center text-gray-600">We hebben je afspraak bevestigd. Je ontvangt binnenkort een e-mailbevestiging.</p>

                {/* Knop in het midden centreren */}
                <div className="flex justify-center mt-4">
                    <button
                        onClick={handleClose}
                        className="bg-[#175151] text-white px-4 py-2 rounded hover:bg-[#148c87] transition"
                    >
                        Sluiten
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ThankYouModal;
